// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { chainIdToChainConfigurationValues, testAssetChains } from './DeploymentConfigsDefaults'
import { StageConfiguration } from './DeploymentConfigTypes'
import { ChainConfiguration } from './DeploymentConfigTypes'
import { ChainId } from './Enums'
const cognitoRegion = 'us-east-1'
const cognitoOTUserPoolId = 'us-east-1_GahGaxth9' // IN Production these are 2 different pools
//const cognitoLytUserPoolId = 'us-east-'

const SANDBOX_SEPOLIA_FRONTEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/C2preuKi6gctek2xm0eYF'
const SANDBOX_SEPOLIA_BACKEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/ZusYanyOFeHQBHqjCrw3R'
const SANDBOX_FUJI_FRONTEND_URL = 'https://avax-fuji.g.alchemy.com/v2/rVoz9ehjmnDc5Etx5YEry'
const SANDBOX_FUJI_BACKEND_URL = 'https://avax-fuji.g.alchemy.com/v2/jxIKtD4v8GHBDV-sI-eYV'

// WebSocket URLs
const SANDBOX_SEPOLIA_FRONTEND_WS_URL = 'wss://eth-sepolia.g.alchemy.com/v2/C2preuKi6gctek2xm0eYF'
const SANDBOX_FUJI_FRONTEND_WS_URL = 'wss://avax-fuji.g.alchemy.com/v2/rVoz9ehjmnDc5Etx5YEry'

const SANDBOX_SERVICE_CONFIGURATION_ADDR = '0xf08676003E05175cdD48fbD90b2AC3de230b4CDB' // '0x526eCD1166cD535316627e73BBf092a959a2156F'

const SANDBOX_FUJI_SERVICE_CONFIGURATION_ADDR = '0xF061a3e9fAf00eA3FB8b3316AdDd3eB9792FE13b'

const SANDBOX_PLUME_MAINNET_SERVICE_CONFIGURATION_ADDR = '0x52F5535997C71B40e3b7A59B69F51120Afc86159'

const SANDBOX_REST_API_KEY = 'WE8etBkeeT7a4rhN8G3778KPSScG7Pms7KvFbpq0'

const SANDBOX_CANARY_REST_API_KEY = 'cdyZFw7sCa7ejzNLS56q46jHzoNeTnT97VY9nR1j'

const CHAIN_CONFIG_SANDBOX_FUJI: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.FUJI),
  chainConfigurationName: 'SandboxFuji',
  serviceConfigurationAddr: SANDBOX_FUJI_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: SANDBOX_FUJI_FRONTEND_URL,
  frontendWebSocketProviderUrl: SANDBOX_FUJI_FRONTEND_WS_URL,
  backendProviderUrl: SANDBOX_FUJI_BACKEND_URL,
}

const CHAIN_CONFIG_SANDBOX_PLUME_MAINNET: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.PLUME_MAINNET),
  chainConfigurationName: 'SandboxPlume',
  serviceConfigurationAddr: SANDBOX_PLUME_MAINNET_SERVICE_CONFIGURATION_ADDR,
}

const CHAIN_CONFIG_SANDBOX_SEPOLIA: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.SEPOLIA),
  chainConfigurationName: 'SandboxSepolia',
  serviceConfigurationAddr: SANDBOX_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: SANDBOX_SEPOLIA_FRONTEND_URL,
  frontendWebSocketProviderUrl: SANDBOX_SEPOLIA_FRONTEND_WS_URL,
  backendProviderUrl: SANDBOX_SEPOLIA_BACKEND_URL,
}

export const SANDBOX_STAGE_CONFIG: StageConfiguration = {
  stageName: 'sandbox', // from serverless.yml
  domain: 'app.opentradesandbox.com',
  websocketUrl: 'wss://ws.opentradesandbox.com',
  serverApiBaseUrl: 'https://api.opentradesandbox.com',
  graphqlUrl: 'https://gql.opentradesandbox.com',
  restAPIKey: SANDBOX_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [CHAIN_CONFIG_SANDBOX_SEPOLIA, CHAIN_CONFIG_SANDBOX_FUJI],
  userConnections: [],
  cognitoConfig: {
    clientId: '15l61romc29tet2oua4tpv3f50',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const SANDBOX_CANARY_STAGE_CONFIG: StageConfiguration = {
  stageName: 'sandboxcanary', // from serverless.yml
  domain: 'app.opentradesandboxcanary.com',
  websocketUrl: 'wss://ws.opentradesandboxcanary.com',
  serverApiBaseUrl: 'https://api.opentradesandboxcanary.com',
  graphqlUrl: 'https://gql.opentradesandboxcanary.com',
  restAPIKey: SANDBOX_CANARY_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [CHAIN_CONFIG_SANDBOX_SEPOLIA, CHAIN_CONFIG_SANDBOX_FUJI, CHAIN_CONFIG_SANDBOX_PLUME_MAINNET],
  userConnections: [],
  cognitoConfig: {
    clientId: '323knfuk2aq9i89ekhms7jvjl9',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}
